<template>
  <div class="bodyFix">
    <header id="header">
      <div class="zaki-row">
        <div class="wrapper">
          <span class="icon icon-logo-header"></span>
          <a v-if="isStandalone" class="header-right" @click="goToLogin">
            <span class="icon icon-logo-alone"></span>
            {{ $t('app.common.goBack') }}
          </a>
          <a v-else class="header-right" href="https://www.akern.com">
            <span class="icon icon-logo-alone"></span>
            {{ $t('app.common.returnToSite') }}
          </a>
        </div>
      </div>
    </header>
    <nuxt />
    <footer id="footer">
      <svg
        class="svg-flap"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1920 64"
      >
        <g
          data-name="Group 21"
          transform="translate(662 -53.31)"
          style="isolation: isolate"
        >
          <g transform="translate(-662 53.31)">
            <path
              d="M1258,53.31C393.309,53.31-.752,103.166-662,103.166V117.31H1258Z"
              transform="translate(662 -53.31)"
            ></path>
          </g>
        </g>
      </svg>
      <div class="zaki-row pb-0">
        <div class="wrapper">
          <div class="zaki-col zaki-col-1">
            <span class="icon icon-logo-footer"></span>
          </div>
          <div class="zaki-col zaki-col-2">
            <ul>
              <li>
                <a href="https://www.akern.com/azienda/">Azienda</a>
              </li>
              <li>
                <a href="https://www.akern.com/prodotti-e-soluzioni/"
                  >Prodotti e soluzioni</a
                >
              </li>
              <li>
                <a href="https://www.akern.com/corsi-di-formazione/"
                  >Akern&reg; Academy</a
                >
              </li>
              <li>
                <a href="https://www.akern.com/akern-science/"
                  >Akern&reg; Science</a
                >
              </li>
              <li>
                <a href="https://www.akern.com/category/news/">News</a>
              </li>
            </ul>
          </div>
          <div class="zaki-col zaki-col-3">
            <ul>
              <li>
                <a href="https://www.akern.com/contatti/">Contatti</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="//www.iubenda.com/privacy-policy/55071251/legal"
                  class="iubenda-nostyle iubenda-embed"
                  >Informativa sulla Privacy</a
                >
              </li>
              <li>
                <a
                  target="_blank"
                  href="//www.iubenda.com/privacy-policy/55071251/cookie-policy"
                  class="iubenda-nostyle iubenda-embed"
                  >Informativa sui Cookie</a
                >
              </li>
            </ul>
          </div>
          <div class="zaki-col zaki-col-4">
            <ul class="social">
              <li>
                <a
                  href="https://www.facebook.com/theBIAcompany"
                  title="Facebook"
                  target="_blank"
                  rel="me nofollow"
                >
                  <span class="icon icon-set1-facebook"></span>
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/AkernSrl"
                  title="Twitter"
                  target="_blank"
                  rel="me nofollow"
                >
                  <span class="icon icon-set1-twitter"></span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCZICiBZsWku88GUAaOYJuwA"
                  title="Youtube"
                  target="_blank"
                  rel="me nofollow"
                >
                  <span class="icon icon-set1-youtube"></span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/akern_srl/"
                  title="Instagram"
                  target="_blank"
                  rel="me nofollow"
                >
                  <span class="icon icon-set1-instagram"></span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/akern-srl/"
                  title="Linkedin"
                  target="_blank"
                  rel="me nofollow"
                >
                  <span class="icon icon-set1-linkedin"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="zaki-row pt-0 pb-0">
        <div class="wrapper">
          <p class="website">www.akern.com</p>
        </div>
      </div>
      <div class="zaki-row pt-0">
        <div class="wrapper closure">
          <p class="closure-text">
            Akern s.r.l. &nbsp;|&nbsp; Sede Legale: Via Campodavela 1, 56122,
            Pisa - Italia &nbsp;|&nbsp; Sede Operativa: Via Lisbona 32 50065,
            Pontassieve (Firenze) - Italia &nbsp;|&nbsp; E-mail: akern@akern.com
            &nbsp;|&nbsp; P.IVA IT01783380486
          </p>
        </div>
      </div>
    </footer>
    <GlobalLoader />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalLoader from '~/components/GlobalLoader'

export default {
  components: {
    GlobalLoader,
  },
  computed: {
    ...mapGetters('utils', ['isStandalone']),
  },
  methods: {
    goToLogin() {
      this.$router.push(
        this.localePath({
          name: 'login',
        })
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/_signup.scss';
</style>
